module.exports = __webpack_public_path__ + "static/register-section-e6eba5fa9f6839feec9da7ae9e6d899c.svg";